import tree from "../../../components/tree.vue";
import RepairForm from "./RepairForm/RepairForm.vue"
import RepairOrder from "./RepairOrder/RepairOrder.vue"
import Processed from "./Processed/Processed.vue"
import Closed from "./Closed/Closed.vue"

export default {
    name: 'MaintainManagement',
    components: { tree, RepairForm, RepairOrder, Processed, Closed },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            id: '',
            activeName: 'first',
        }
    },
    created() {
        // 从URL参数中获取tabName，如果存在则设置为当前激活的tab
        if (this.$route.query.tabName) {
            this.activeName = this.$route.query.tabName;
        }
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        cellClick(val) {
            console.log('val====>', val)
            if (val.row.repairStateStr == this.$t('VehicleManagement.form.haveBeenRepaired')) {
                this.activeName = 'second'
                this.$refs.TabMaintenance.orgId = this.orgId
                this.$refs.TabMaintenance.repairSerialNumber = val.row.repairSerialNumber
                this.$refs.TabMaintenance.getMaintainList()
                this.$refs.TabMaintenance.dialogOperateVisible = true
                this.$refs.TabMaintenance.queryDetails()
            } else {
                this.$message.error(this.$t('VehicleManagement.form.noClick'))
            }
        },
        initQuery(item) {
            console.log(item)
            this.orgId = item.id
            if (this.activeName == 'first') {
                this.$refs.TabRepair.orgId = item.id
                this.$refs.TabRepair.getRepairList()
            } 
            else if (this.activeName == 'second') {
                this.$nextTick(() => {
                    this.$refs.TabMaintenance.orgId = item.id
                    this.$refs.TabMaintenance.getMaintainList()
                    console.log(this.$refs.TabMaintenance.orgId)
                })
                
            }
            else if (this.activeName == 'third') {
                this.$nextTick(() => {
                    this.$refs.process.orgId = item.id
                    this.$refs.process.getRepairList()
                })
                
            }
            else {
                this.$nextTick(() => {
                    this.$refs.close.orgId = item.id
                    this.$refs.close.getRepairList()
                })
                
            }
        },
        nodeClick(val) {
            this.orgId = val.label
            if (this.activeName === 'first') {
                this.$refs.TabRepair.orgId = val.label
                this.$refs.TabRepair.getRepairList()
            } else if (this.activeName === 'second') {
                this.$nextTick(() => {
                    this.$refs.TabMaintenance.orgId = val.label
                    this.$refs.TabMaintenance.getMaintainList()
                })
            } else if (this.activeName === 'third') {
                this.$nextTick(() => {
                    this.$refs.process.orgId = val.label
                    this.$refs.process.getRepairList()
                })
            } else {
                this.$nextTick(() => {
                    this.$refs.close.orgId = val.label
                    this.$refs.close.getRepairList()
                })
            }
        },
        handleClick(event) {
            console.log(event)
            this.activeName = event.name
            if (this.activeName == 'first') {
                this.$refs.TabRepair.getRepairList(this.orgId)
            } else if (this.activeName == 'second') {
                this.$nextTick(() => {
                    this.$refs.TabMaintenance.orgId = this.orgId
                    this.$refs.TabMaintenance.getMaintainList()
                })
            } else if (this.activeName == 'third') {
                this.$nextTick(() => {
                    this.$refs.process.orgId = this.orgId
                    this.$refs.process.getRepairList()
                })
            } else {
                this.$nextTick(() => {
                    this.$refs.close.orgId = this.orgId
                    this.$refs.close.getRepairList()
                })
            }
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}